import InformationTabBase from "./InformationTabBase";
import StatsAndVideosPerMatchDataTable from "../datatables/StatsAndVideosPerMatchDataTable";
import React from "react";
import TransfersDataTable from "../datatables/TransfersDataTable";
import manchesterUnitedLogo from '../../../../../assets/img/demo/manchester-united-logo.png';
import realMadridLogo from '../../../../../assets/img/demo/real-madrid-logo.png';
import {gql, useQuery} from "@apollo/client";
import {connect} from "react-redux";
import Tools from "../../../../../Tools";

class TransfersTab extends InformationTabBase {
    /**
     * Renders the content of Transfers tab.
     * @returns {React.ReactNode} The Transfers tab.
     */
    render = () => {
        return (
            <div className="transfers-tab">
                {this.renderTable()}
            </div>
        );
    };

    renderTable = () => {
        const {playerId} = this.props;

        return (
            <TransfersDataTable playerId={playerId}/>
        );
    };
}

const mapStateToProps = (state) => {
    return {
        playerId: state.full_profile.playerId
    }
};

export default connect(mapStateToProps, null)(TransfersTab);
